import { CaseDraft, ChatFeedback } from '../store/types';

export type ChatRequestMessage = {
  content: string;
  role: string;
};

export type ChatRequest = {
  message: string;
};

// Each ChatResponse... type represents one of the types that can be returned from /chat endpoint.
// It's important to keep them in sync with changes in API code.

export interface ChatResponseContentStream {
  content: string;
  // When true, the client must replace (not append to) the accumulated answer: the turn was
  // stopped by a prompt-leakage guardrail.
  contentBlocked?: boolean;
}

export interface ChatResponseDraft {
  case: CaseDraft;
  content?: string;
  fieldLabels?: Record<string, string>;
}

export interface ChatResponseCase {
  caseCreationStatus: CaseCreationStatus;
  caseId?: number;
  content?: string;
  caseLinkText?: string;
  validationErrors?: string[];
  userErrorMessages?: string[];
}

export enum CaseCreationStatus {
  created = 'created',
  failed = 'failed',
}

export type ChatResponseRawText = string;

export interface ChatResponseGenericError {
  error: {
    status: number;
    message: string;
  };
}

export interface ChatResponseInvalidRequest {
  errors: { type: string }[];
}

export type ChatResponse = ChatResponseContentStream &
  ChatResponseDraft &
  ChatResponseCase &
  ChatResponseRawText &
  ChatResponseGenericError &
  ChatResponseInvalidRequest;

export interface FeedbackRequest extends ChatFeedback {
  messages: ChatRequestMessage[];
  draft?: CaseDraft;
}
